import { initializeApp, getApps } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "",
};

const hasConfig = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.authDomain &&
    firebaseConfig.projectId &&
    firebaseConfig.appId
);

const app = hasConfig ? (getApps()[0] ?? initializeApp(firebaseConfig)) : null;
export const firebaseAuth = app ? getAuth(app) : null;
export const isFirebaseConfigured = hasConfig;

export const googleProvider = new GoogleAuthProvider();

